
export class PredictiveSearch {

    constructor() {
        this.selectors = {
            searchTriggers: '.search-trigger',
            resultsWrapper: '.predictive-search-container',
            resultsInner: '.predictive-search-container .inner.predictive-inner',
            closeButton: '.predictive-search-container .close',
            recommendedInner: '.predictive-search-container .inner.recommended-inner',
            recommendedSwiper: '.predictive-search-container .inner.recommended-inner .swiper.search-recommendations-swiper',
            recentPlaceholder: '.predictive-search-container .inner.recommended-inner .sidebar-group.recent-searches',
            recentContainer: '.predictive-search-container .inner.recommended-inner .sidebar-group.recent-searches .recent-search-container',
            searchBar: '.predictive-search-bar',
            headerOpenSearch: '.mega-menu .search[data-open-search]',
        };

        this.sectionId = "kt-predictive-search";

        this.init();
    }



    init() {
        const { searchTriggers, closeButton, resultsWrapper, resultsInner, recommendedContainer } = this.selectors;

        document.querySelectorAll(searchTriggers).forEach( searchBar => {
            searchBar.addEventListener('keyup', () => this.handleSearch(searchBar.value));

            //searchBar.addEventListener('focus', () => { document.querySelector( resultsWrapper ).classList.add('active'); })
        });

        document.querySelector( closeButton )?.addEventListener( 'click', () => this.closeResults() );

        this.getRecentSearches();
        this.initRecommendedProductsSwiper();
    }



    handleSearch(query) {

        const resultsWrapper = document.querySelector( this.selectors.resultsWrapper );
        const resultsInner = document.querySelector( this.selectors.resultsInner );
        const recommendedInner = document.querySelector( this.selectors.recommendedInner );

        if( query.length > 2 ){

            var requestResponse;
            fetch(`/search/suggest?q=${ query }&resources[type]=product,collection,article,page&resources[options][fields]=title,body,product_type,variants.title,tag&resources[limit_scope]=each&section_id=${ this.sectionId }`)
            .then((response) => {
                requestResponse = response;
                return response.text();
            })
            .then((text) => {
                if (!requestResponse.ok) {
                    throw new Error(`${ requestResponse.status }: ${ text }`);
                }
                resultsWrapper.classList.add('active');
                resultsInner.style.display = 'grid';
                resultsInner.classList.remove('no-results');
                recommendedInner.style.display = 'none';
                recommendedInner.classList.add('no-results');

                const parsedDoc = new DOMParser().parseFromString(text, 'text/html');
                const sectionEl = parsedDoc.querySelector(`#shopify-section-${this.sectionId}`);
                const resultsMarkup = sectionEl.innerHTML;

                // If the section element is missing or contains a no-results indicator...
                if (!sectionEl || sectionEl.querySelector('.no-results')) {
                    this.handleNoResultsFull();
                }

                resultsInner.innerHTML = resultsMarkup;

                // Select all product card Swiper containers
                const productSwipers = document.querySelectorAll('.productCardSwiper');
                
                productSwipers.forEach((swiperEl) => {
                    if (swiperEl.classList.contains('swiper-initialized')) return; // Prevent duplicate initialization
                
                    new window.swiper(swiperEl, {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    nested: true,
                    navigation: {
                        nextEl: swiperEl.querySelector('.productCardSwiper-next'),
                        prevEl: swiperEl.querySelector('.productCardSwiper-prev'),
                    },
                    lazy: true, // Enable lazy loading
                    preloadImages: false,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    });
                
                    swiperEl.classList.add('swiper-initialized'); // Mark as initialized
                });
            })
            .catch((error) => {
                console.error(error);
            });

        } else {
            this.handleNoResults();
        }
    }

    handleNoResults() {
        const resultsInner = document.querySelector( this.selectors.resultsInner );
        const recommendedInner = document.querySelector( this.selectors.recommendedInner );

        resultsInner.innerHTML = '';
        resultsInner.style.display = 'none';
        resultsInner.classList.remove('no-results');
        recommendedInner.style.display = 'grid';
        recommendedInner.classList.remove('no-results');
    }

    handleNoResultsFull() {
        const resultsInner = document.querySelector( this.selectors.resultsInner );
        const recommendedInner = document.querySelector( this.selectors.recommendedInner );

        resultsInner.classList.add('no-results');
        recommendedInner.style.display = 'grid';
        recommendedInner.classList.add('no-results');
    }

    closeResults() {
        const resultsInner = document.querySelector( this.selectors.resultsInner );
        const recommendedInner = document.querySelector( this.selectors.recommendedInner );
        const resultsWrapper = document.querySelector( this.selectors.resultsWrapper );
        const searchBar = document.querySelector( this.selectors.searchBar );
        const headerOpenSearch = document.querySelector( this.selectors.headerOpenSearch );

        resultsInner.innerHTML = '';
        resultsInner.style.display = 'none';
        resultsInner.classList.remove('no-results');
        recommendedInner.style.display = 'grid';
        recommendedInner.classList.remove('no-results');

        resultsWrapper.classList.remove('active');
        searchBar.classList.remove('active');
        headerOpenSearch.classList.remove('active');
    }

    initRecommendedProductsSwiper() {
        const swiper_recommended_el = document.querySelector(this.selectors.recommendedSwiper);

        if ( swiper_recommended_el ) {

            const swiper_recommended = new window.swiper(this.selectors.recommendedSwiper, {
                slidesPerView: 2.5,
                spaceBetween: 10,
                slidesOffsetAfter: 21,
                slidesOffsetBefore: 21,

                breakpoints: {
                    450: {
                        slidesPerView: 3
                    },
                    768: {
                        slidesPerView: 3,
                        slidesOffsetAfter: 0,
                        slidesOffsetBefore: 0
                    },
                    992: {
                        slidesPerView: 4
                    },
                    1200: {
                        slidesPerView: 5
                    }
                },
            });

        }

    }

    getRecentSearches() {
        const recentPlaceholder  = document.querySelector( this.selectors.recentPlaceholder );
        const recentContainer = recentPlaceholder.querySelector( this.selectors.recentContainer );

        const RECENT_SEARCHES_LOCAL_KEY = window.Shopify.shop.replace(/.myshopify.com/g,'') + '__recentSearches';
        const RECENT_SEARCHES_LOCAL = JSON.parse( localStorage.getItem(RECENT_SEARCHES_LOCAL_KEY) );

        if ( recentPlaceholder && recentContainer && RECENT_SEARCHES_LOCAL && RECENT_SEARCHES_LOCAL.length > 0 ) {
            const recentArrReverse = RECENT_SEARCHES_LOCAL.reverse();
            const recentSearchFragment = document.createDocumentFragment();

            recentArrReverse.forEach( searchTerm => {
                const searchLink = '/search?q=' + searchTerm + '&type=product';
                const linkNode = document.createElement('a');

                linkNode.setAttribute('href', searchLink);
                linkNode.textContent = searchTerm;
                linkNode.classList.add('link');

                recentSearchFragment.appendChild( linkNode );
            });

            recentContainer.appendChild( recentSearchFragment );

        } else {
            if ( recentPlaceholder ) recentPlaceholder.remove();
        }
    }
}